export enum EReligion {
  ORTHODOX = 'orthodox',
  CATHOLIC = 'catholic',
  MUSLIM = 'muslim',
  OTHER = 'other',
}
